import { EntityPreviewLink } from '@/features/preview/EntityPreviewLink'
import { adminRoutes } from '@/routes'

type Props = {
  _id: string
  name?: string
}

export const CarrierLink = ({ _id, name }: Props) => (
  <EntityPreviewLink
    type="carrier"
    _id={_id}
    name={name}
    to={adminRoutes.carrierPage(_id)}
  />
)
